import { render, staticRenderFns } from "./tenant-details.vue?vue&type=template&id=46a9a0b4"
import script from "./tenant-details.vue?vue&type=script&lang=js"
export * from "./tenant-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports